import * as React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент осуществляет анимацию переходов между экранами вопросов
 * Анимация в виде эффекта перелистывания
 * Поддерживается анимация в соответствующие стороны при навигации вперед и назад
 * */
export var QuestionSwitchAnim = function QuestionSwitchAnim(props) {
  var isBackwards = props.isBackwards;
  return /*#__PURE__*/_jsx(SwitchTransition, {
    mode: "out-in",
    children: /*#__PURE__*/_jsx(CSSTransition, {
      classNames: {
        enter: isBackwards ? styles['animation-enter-prev'] : styles['animation-enter'],
        enterActive: isBackwards ? styles['animation-enter-prev-active'] : styles['animation-enter-active'],
        exit: styles['animation-exit'],
        exitActive: styles['animation-exit-active']
      },
      addEndListener: /* istanbul ignore next код из доки, юнит писать бессмысленно */
      function addEndListener(node, done) {
        return node.addEventListener('transitionend', done);
      },
      children: /*#__PURE__*/_jsx("div", {
        className: styles['container'],
        "data-testid": "question-animation",
        children: props.children
      })
    }, props.currentScreenId)
  });
};
QuestionSwitchAnim.displayName = 'QuestionSwitchAnim';